import gql from 'graphql-tag';

import type { BrandTerm } from 'src/data/brandTerm';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteBrandTerm($id: ID!) {
    deleteBrandTerm(id: $id) {
      id
    }
  }
`;

export const deleteBrandTerm = async (id: ID): Promise<BrandTerm | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  });

  return getSingleProp<BrandTerm>(result.data);
};
